<template>
    <div id="home-pc">
        <!-- header -->
        <div class="header-wrap" id="header-wrap-id">
            <a id="s-summary"></a>
            <transition name="fade">
            <div class="nav" v-show="showNav">
                <ul>
                    <img class="menu-logo" src="../assets/e-pc/logo.png" alt="">
                    <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-summary">首页</a></li>
                    <li v-if="false"><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#past-guest">往期嘉宾</a></li>
                    <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-guest">确定嘉宾</a></li>
                    <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-agenda">大会议程</a></li>
                    <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-award">奖项评选</a></li>
                    <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-tickets">参会购票</a></li>
                    <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="https://www.bufanbiz.com/explore/bufan2018/news/" target="_blank">大会直播</a></li>
                    <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-partners">合作机构</a></li>
                    <li><a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="#s-contact-us">联系我们</a></li>
                </ul>
            </div>
            </transition>
        </div>
        <!-- 往期嘉宾 -->
        <div v-if="false" class="section past-guest" id="past-guest">
            <p id="s-past-guest"></p>
            <div class="s-title">
                <div class="en"> PAST GUEST</div>
                <div class="zh"> 往期嘉宾</div>
            </div>
            <ul>
                <li>
                    <a href="https://www.bufanbiz.com/post/5069.html" target="_blank">
                        <img src="../assets/e-wap/jim.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
                <li>
                    <a href="https://www.bufanbiz.com/post/5072.html" target="_blank">
                        <img src="../assets/e-wap/zhangying.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
                <li>
                    <a href="https://www.bufanbiz.com/post/5078.html" target="_blank">
                        <img src="../assets/e-wap/tuobuhua.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
                <li>
                    <a href="https://www.bufanbiz.com/post/1897.html" target="_blank">
                        <img src="../assets/e-wap/qasar.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
                <li>
                    <a href="https://www.bufanbiz.com/post/1916.html" target="_blank">
                        <img src="../assets/e-wap/xiaowenjie.png">
                        <img class="play-btn" src="../assets/e-wap/play.png">
                    </a>
                </li>
            </ul>
        </div>
        <!-- 已邀嘉宾 -->
        <div id="guest-bg-area">
            <div class="section guest" id="guest-wrap-id">
                <p id="s-guest"></p>
                <div class="s-title">
                    <div class="en">GUESTS</div>
                    <div class="zh">确定嘉宾</div>
                    <span style="font-size: 16px; padding-left: 20px;">排名不分先后</span>
                </div>
                <ul class="guest-list">
                    <li v-for="(guest, index) in guestList">
                        <div class="photo">
                            <div class="left-top"></div>
                            <img :src="guest.photo" alt="嘉宾姓名">
                            <div class="right-bottom"></div>
                        </div>
                        <div class="name-wrap">
                            <div class="name">{{ guest.name }}</div>
                            <div class="company">{{ guest.position }}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- agdnda day1 -->
        <div class="section agenda">
            <p id="s-agenda"></p>
            <div class="s-title">
                <div class="en"> AGENDA </div>
                <div class="zh"> 大会议程 </div>
            </div>

            <transition name="fade">
                <div v-if="false" :class="showagendamenu ? 'agenda-menu' : 'agenda-menu2'">
                    <div class="date" @click="gotoagenda('date1')"></div>

                    <template v-if="agendadata.type && agendadata.type[0] && agendadata.type[0].length > 0">
                        <template  v-for="(item,index) in agendadata.type[0]">
                            <template v-if="index < 4">
                                <div class="item "
                                    :class="[{'active-agenda-menu': activeagendamenu == item }, 'bg-color-' + index]"
                                    v-on:mouseover="changecurrentagenda(item,index)"
                                    @click="changecurrentagenda(item,index)">
                                    {{ item.split('|')[0] }}
                                </div>
                            </template>
                        </template>
                     </template>
                </div>
            </transition>

            <template v-for="(type,index) in agendaData.type[0]">
                <div :class="'agenda-group-'+index">
                    <div :class="'agenda-group-center-'+index" class="agenda-group-center">
                        <div class="conf-host" :class="'agenda-theme-' + index" >
                            <div class="which-conf"> <span v-html="type"></span> <a href="http://j.map.baidu.com/h4z9P" class="see-map" target="_blank">查看地图</a></div>
                        </div>
                        <div class="agenda-list">
                            <template v-for="(agenda,index) in agendaData.meeting[type]">
                                <agenda-item :data="agenda" :index="index"></agenda-item>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <!-- agdnda day2 -->
        <div class="section agenda">
            <template v-for="(type,index) in agendaData.type[1]">
                <div :class="'agenda-group-'+index">
                    <div :class="'agenda-group-center-'+index" class="agenda-group-center">
                        <div class="conf-host" :class="'agenda-theme-' + index" >
                            <div class="which-conf"> <span v-html="type"></span> <a href="http://j.map.baidu.com/h4z9P" class="see-map" target="_blank">查看地图</a></div>
                        </div>
                        <div class="agenda-list">
                            <template v-for="(agenda,index) in agendaData.meeting[type]">
                                <agenda-item :data="agenda" :index="index"></agenda-item>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <!-- AWARD 奖项评选 -->

        <div id="award-area">

            <p id="s-award"></p>
            <div class="section award">
                <div class="s-title">
                    <div class="en"> AWARD </div>
                    <div class="zh"> 奖项评选 </div>
                </div>

                <div class="award-content">
                    <a href="https://www.bufanbiz.com/explore/2018vote/#!/topstartups" target="_blank">         <img src="../assets/e-pc/award1.jpg"> </a>
                    <a href="https://www.bufanbiz.com/explore/2018vote/#!/topvc" target="_blank">               <img src="../assets/e-pc/award2.jpg"> </a>
                    <a href="https://www.bufanbiz.com/explore/2018vote/#!/topinvestorunder30" target="_blank">  <img src="../assets/e-pc/award3.jpg"> </a>
                    <a href="https://www.bufanbiz.com/explore/2018vote/#!/topinvestorunder40" target="_blank">  <img src="../assets/e-pc/award4.jpg"> </a>
                </div>
            </div>
        </div>

        <!-- 参会人群分析-->
        <div id="participator-area">
            <div class="section tickets">
                <div class="s-title">
                    <div class="en"> SAFF ANALYSIS </div>
                    <div class="zh"> 参会人群分析</div>
                </div>

                <div class="participator-content">
                    <div class="item"><div class="title">确定嘉宾</div> <div class="count" id="countup-target1"> 0+</div></div>
                    <div class="item"><div class="title">演讲嘉宾</div> <div class="count" id="countup-target2"> 0+</div></div>
                    <div class="item"><div class="title">会议嘉宾</div> <div class="count" id="countup-target3"> 0+</div></div>
                    <div class="item"><div class="title">榜单</div>     <div class="count" id="countup-target4">  0+</div></div>
                    <div class="item"><div class="title">参展企业</div> <div class="count" id="countup-target5"> 0+</div></div>
                    <div class="item"><div class="title">媒体</div>    <div class="count" id="countup-target6"> 0+</div></div>
                </div>
            </div>
        </div>

        

        <!-- tickets  -->
        <div id="tickets-bg-area">
            <div class="section tickets">
                <p id="s-tickets"></p>
                <div class="s-title">
                    <div class="en"> TICKETS </div>
                    <div class="zh"> 参会购票 </div>
                </div>
                <a  v-if="false" class="rogers-area" href="https://jinshuju.net/f/Jlf1js" target="_blank">
                    <div class="rogers">
                        <img src="../assets/n-pc/pc-rogers.png">
                    </div>
                    <div class="ticket-info">
                        <div class="name">
                            尊享票
                        </div>
                        <div class="price-line">
                            <span class="price"> 36666元 </span>
                            <span> 限10位名额，需审核</span>
                        </div>
                        <div class="intro-line">
                            与国际著名投资大师吉姆·罗杰斯半天闭门沟通会 <br>
                            SSVIP尊享座位，2天通票，尽享4场论坛，20+主题演讲 <br>
                            闭门晚宴入场券，与全球最强创投大脑亲密social <br>
                            限企业/投资机构创始人、高管报名，需要审核 <br>
                        </div>
                    </div>
                    <div class="buy-btn">
                    </div>
                    <div class="rogers-tickets">
                    </div>
                </a>

                <div class="tickets-content">
                    <a class="ticket3" :href="ticketUrl" target="_blank">
                        <div class="ticket-item">
                            <div class="name">
                                限时优惠票
                            </div>
                            <div class="price">
                              9.9元&nbsp;
                            </div>
                            <div class="content">
                                2天通票，尽享3场论坛（主论坛除外），15+主题演讲 <br>
                                4000屏幕展览互动体验 <br>
                                限时特惠，数量有限 <br>
                            </div>
                            <div class="seat">
                                座位先到先得
                            </div>
                            <div class="buy-btn">
                            </div>
                        </div>
                    </a>
                    <a class="ticket0" :href="ticketUrl" target="_blank">
                        <div class="ticket-item">
                            <div class="name">
                                早鸟参会票
                            </div>
                            <div class="price">
                              99元&nbsp;
                            </div>
                            <div class="content">
                                2天通票，尽享4场论坛，20+主题演讲  <br>
                                4000平米展览互动体验 <br>
                                座位先到先得<br>
                            </div>
                            <div class="seat">
                              有限席位
                            </div>
                            <div class="buy-btn">
                            </div>

                        </div>
                    </a>
                    <a class="ticket1" :href="ticketUrl" target="_blank">
                        <div class="ticket-item">
                            <div class="name">
                              2天峰会通票
                            </div>
                            <div class="price">
                              299元&nbsp;
                            </div>
                            <div class="content">
                                2天通票，尽享4场论坛，20+主题演讲 <br>
                                 4000平米展览互动体验 <br>
                                座位先到先得 <br>
                            </div>
                            <div class="seat">
                              有限席位
                            </div>
                            <div class="buy-btn"> </div>
                        </div>
                    </a>
                    <a class="ticket2" :href="ticketUrl" target="_blank">
                        <div class="ticket-item">
                            <div class="name">
                              CEO票
                            </div>
                            <div class="price">
                              999元&nbsp;
                            </div>
                            <div class="content">
                              2天通票，尽享4场论坛，20+主题演讲 <br>
                              4000平米展览互动体验<br>
                              保证前排座位<br>
                              演讲嘉宾可公开 PPT 独家分享<br>
                            </div>
                            <div class="seat">
                              有限席位，仅限 CEO 参加
                            </div>
                            <div class="buy-btn">
                            </div>

                        </div>
                    </a>
                    <a v-if="false" class="ticket3" :href="ticketUrl" target="_blank">
                        <div class="ticket-item">
                            <div class="name">
                              晚宴入场券
                            </div>
                            <div class="price">
                              9999元&nbsp;
                            </div>
                            <div class="content">
                                闭门晚宴入场券<br>
                                将有机会与全球最强创投大脑<br>
                                亲密social <br>
                                CEO 票所有权益<br>
                            </div>
                            <div class="seat">
                              有限席位，报名需审核
                            </div>
                            <div class="buy-btn">
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <!-- old guests -->
        <div id="old-guest-bg-area" v-if="false">
            <div class="section old-guests">
                <p id="s-old-guest"></p>
                <div class="s-title"> <img src="../assets/n-pc/title-old-guests.png"> </div>
                <div class="container">
                    <div v-for="item in oldGuests" class="old-guest-item">
                        <img :src="item.img">
                        <div class="guest-name"> {{ item.name }} </div>
                        <div class="guest-title">{{ item.title }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- faq -->
        <div id="faq-bg-area">
            <div class="section faq">
                <p id="s-faq"></p>
                <div class="s-title">
                    <div class="en"> FAQ </div>
                    <div class="zh"> 参会指南 </div>
                </div>
                <div class="container">
                    <div class="faq-item">
                        <div class="line-q">
                            <span>Q:</span>
                            <div class="content">
                                购票什么时候截止?
                            </div>
                        </div>
                        <div class="line-a">
                            <span>A:</span>
                            <div class="content">
                                购票截止日期为2018年11月12日。
                            </div>
                        </div>

                        <div class="line-q">
                            <span>Q:</span>
                            <div class="content">
                                购票付款成功后，如何获得参会凭证？
                            </div>

                        </div>
                        <div class="line-a">
                            <span>A:</span>
                            <div class="content">
                                在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。 <br>
                                活动开始前一周，还会短信发送一次参会信息。如果您关注了不凡商业（微信号：bufanbiz），届时也会有相应的提醒。
                            </div>
                        </div>


                        <div v-if="false" class="line-q">
                            <span>Q:</span>
                            <div class="content">
                                是否可以团体购票？
                            </div>
                        </div>
                        <div v-if="false" class="line-a">
                            <span>A:</span>
                            <div class="content">
                                在小饭桌大会官网购票，一次订购5张及以上享受9折优惠；一次购买10张及以上享受8折优惠。
                            </div>
                        </div>

                        <div class="line-q" v-if="false">
                            <span>Q:</span>
                            <div class="content">
                                是否可以申请发票？
                            </div>
                        </div>
                        <div class="line-a" v-if="false">
                            <span>A:</span>
                            <div class="content">
                                当您的购票订单付款成功后，会有相应的申请发票入口。也可 <a href="http://www.xfz.cn/order/" target="_blank" style="color: #fff;">点此申请发票</a>，在相应的订单下方点击申请发票即可。
                            </div>
                        </div>
                        <div class="line-a">
                            <div class="sa-title">温馨提示：</div>
                            <div class="sa-content">
                                1) 大会门票仅开具增值税普通发票，不提供增值税专用发票；<br>
                                2) 开票内容为：会议服务费 <br>
                                3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。<br>
                            </div>
                        </div>

                        <template v-if="showMoreFaq">
                        <div class="line-q"> <span>Q:</span>
                            <div class="content">
                                观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？
                            </div>
                        </div>
                        <div class="line-a"> <span>A:</span>
                            <div class="content">
                                请您核对票务权益，早鸟票、峰会通票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。
                            </div>
                        </div>

                        <div class="line-q"> <span>Q:</span>
                            <div class="content">
                                大会现场有同声传译服务吗？如何领取同传设备？
                            </div>
                        </div>
                        <div class="line-a"> <span>A:</span>
                            <div class="content">
                                有，活动当天请凭借本人身份证，到指定地点换区同传设备，活动结束后，请及时归还同传设备并取回身份证。
                            </div>
                        </div>

                        <div class="line-q"> <span>Q:</span>
                            <div class="content">
                                大会场馆附近有就餐的地方吗？
                            </div>
                        </div>
                        <div class="line-a"> <span>A:</span>
                            <div class="content">
                                酒店6层设有自助餐厅；距会场2-7分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅等，价位不等，有多样选择。
                            </div>
                        </div>
                        </template>
                        <div class="faq-more-btn" @click="showMoreFaq = !showMoreFaq">
                            <span v-if="!showMoreFaq">查看更多</span><span v-else>点击收起</span></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- partners  -->
        <div id="partners-bg-area">
            <div class="section partners">
                <p id="s-partners"></p>
                <div class="s-title">
                    <div class="en"> PARTNERS </div>
                    <div class="zh"> 合作机构 </div>
                </div>
                <div class="container">
                    <dl>
                        <template v-for="partner in partnerList">
                            <template v-for="(val, key) in partner">
                                <dt>{{ key }}</dt>
                                <dd>
                                    <img v-for="pic in val" :src="pic.logo + '-fintech.partner'">
                                </dd>
                            </template>
                        </template>
                    </dl>
                </div>
            </div>
        </div>

        <!-- location -->
        <div class="section location">
            <p id="s-location"></p>

            <div class="s-title">
                <div class="en"> ADDRESS </div>
                <div class="zh"> 会议地址 </div>
            </div>

            <div class="container">
                <div class="location-wrap">
                    <div class="address-info">
                        <div>
                            会场地址：国贸站 G 东南口出，890 米即到
                        </div>
                        <div>
                            地铁路线：大望路站 D 西北口出，649 米即到
                        </div>
                        <div>
                            驾车路线：北京市朝阳区建外大街建国路93号万达广场 C 座
                        </div>
                    </div>
                    <img src="../assets/e-pc/map.png" alt="">
                </div>
            </div>
        </div>

        <!-- about us -->
        <div class="section about-us">
            <p id="s-contact-us"></p>
            <div class="s-title">
                <div class="en"> CONTACT US</div>
                <div class="zh"> 联系我们 </div>
            </div>
            <div class="about-us-wrap">
                <div class="user-item">
                    <div class="title">赞助合作</div>
                    <div class="name">李成坤</div>
                    <div class="phone">138-1187-2225</div>
                    <div class="email">chengkun@bufanbiz.com</div>
                </div>

                <div class="user-item">
                    <div class="title">媒体合作</div>
                    <div class="name">赵子悠</div>
                    <div class="phone">185-4513-1578</div>
                    <div class="email">zhaobo@bufanbiz.com</div>
                </div>

                <div class="user-item">
                    <div class="title">报名咨询</div>
                    <div class="name">罗阳</div>
                    <div class="phone">188-1179-5758</div>
                    <div class="email">luoyang@bufanbiz.com</div>
                </div>
                <div class="qrcode">
                    <img src="https://www.bufanbiz.com/static/build/images/footer-wx-share.png">
                    <div class="qrcode-info">
                        <span>扫描二维码<br> 关注不凡商业</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-buy-link-float" >
            <a class="nav-link" data-scroll data-options='{ "easing": "easeInQuad" }'  href="https://www.bufanbiz.com/explore/bufan2018/news/" target="_blank">
                <img src="../assets/e-pc/live-logo.png">
            </a>
        </div>
    </div>
</template>

<script>

import AgendaItem from './AgendaItem'
import TicketItem from './TicketItem'
import util from '../assets/js/util'
import oldGuests from '../assets/js/guest_data'

export default{
    components: {
        AgendaItem,TicketItem
    },
    data(){
        return{
            showNav: true,
            showAgendaMenu: false, // 固定的 menu
            showAgendaMenu2: true,// 不固定的 menu
            guestList: [],  // 嘉宾
            partnerList: [], // 合作伙伴
            agendaData: {
                meeting: {},
                type:[]
            }, // 日程列表
            whichConf:'', // 哪个会议
            whichHost:'', // 哪个主持人
            currentAgendaData: [],
            activeAgendaMenu: '',
            activeAgendaMenuIndex: 0,
            showMoreFaq: false,
            oldGuests: oldGuests,
            ticketUrl: "https://www.bufanbiz.com/apply/conference/?code=FskyfwKLMm",
        }
    },
    methods:{
        getGuestData() {
            var self = this
            util.resource({
                url: '/explore/bufan2018_api/guest/',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.guestList = res.data
                    }
                }
            })
        },
        getPartnerData() {
            var self = this
            util.resource({
                url: '/explore/bufan2018_api/company/',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.partnerList = res.data
                    }
                }
            })
        },
        getAgendaData() {
            var self = this
            util.resource({
                url: '/explore/bufan2018_api/meeting/',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.agendaData = res.data
                        self.activeAgendaMenu = self.agendaData.type[0][0] // 默认显示第一个议程
                        self.changeCurrentAgenda(self.activeAgendaMenu,0)
                    }
                }
            })
        },
        changeCurrentAgenda(agenda,index){
            this.whichConf = agenda.split('|')[0]
            this.whichHost = agenda.split('|')[1]
            this.activeAgendaMenu = agenda
            this.activeAgendaMenuIndex = index
            this.currentAgendaData = this.agendaData.meeting[agenda]
        },
        gotoAgenda(date){
            location.href = "#s-agenda"
            if(date == 'date1'){
                this.changeCurrentAgenda(this.agendaData.type[0][0],0)
            } else if (date == 'data2'){
                this.changeCurrentAgenda(this.agendaData.type[1][0],4)
            }
        },
        gotoVipAgenda(title){
            this.whichConf = title.split('|')[0]
            this.whichHost= title.split('|')[1]
            this.changeCurrentAgenda(this.agendaData.type[0][4])
        },
        listenScroll() {
            var self = this
            var offset = $('#participator-area').offset().top + 200
            var flag = true;
            $(window).scroll(function () { 
                var scrollTop = $(window).scrollTop();
                if (scrollTop > offset ){
                    if (flag) {
                        self.runCountUp();
                        flag = false;
                    }
                }
            });
        },
        runCountUp() {
            var options = {
              useEasing: true, 
              useGrouping: true, 
              separator: ',', 
              decimal: '.', 
              suffix: '+' 
            };
            var countup1 = new CountUp('countup-target1', 0, 5000, 0, 3.5, options);
            var countup2 = new CountUp('countup-target2', 0, 100, 0, 3.5, options);
            var countup3 = new CountUp('countup-target3', 0, 50, 0, 3.5, options);
            var countup4 = new CountUp('countup-target4', 0, 4, 0, 3.5, options);
            var countup5 = new CountUp('countup-target5', 0, 60, 0, 3.5, options);
            var countup6 = new CountUp('countup-target6', 0, 150, 0, 3.5, options);
            if (!countup1.error) {
              countup1.start();
              countup2.start();
              countup3.start();
              countup4.start();
              countup5.start();
              countup6.start();
            } else {
              console.error(demo.error);
            }
        },
    },
    mounted(){
        document.title = '2018不凡商业全球青年创业者大会！_不凡商业'
        this.getGuestData()
        this.getPartnerData()
        this.getAgendaData()
        this.listenScroll()
        // util.getWx()
    }
}
</script>

<style lang="scss" scoped>
#home-pc{
    font-size: 14px;
    min-width: 1200px;
    min-height: 200px;
    background-color: black;
    .header-wrap{
        height: 1000px;
        background: url('../assets/e-pc/banner.png');
        background-repeat: no-repeat;
        background-position: 50%;
        .menu-logo {
            float: left;
            width: 160px;
            margin-left: 70px;
            margin-top: 10px;
        }
        .nav{
            position: fixed;
            top:0;
            left: 0;
            z-index: 999;
            right: 0;
            text-align: right;
            padding-right: 200px;
            background-color: rgba(0,0,0,0.3);
            ul {
                width: 1150px;
                margin: 0 auto;
                width: 1150px;
                display: block;
                li {
                    height: 50px;
                    line-height: 50px;
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 18px;
                    display: inline-block;
                    list-style: none;
                    padding-right: 20px;
                    img{
                        height: 35px;
                        float: left;
                        padding-top:10px;
                    }
                    span{
                        color: #fff;
                        font-size: 18px;
                    }
                    a {
                        text-decoration: none;
                        color: #fff;
                    }
                    &:hover {
                        .nav-link{
                            // background-color: #ec1c24;
                            border-bottom: 4px solid #ec1c24;
                            padding-bottom: 11px;
                            color: #fff;
                        }
                    }
                }
                .active{
                    background-color: #0079cf;
                }
            }
        }
    }
    .past-guest {
        ul {
            width: 1200px;
            margin: 0 auto;
            text-align: center;
            li {
                display: inline-block;
                width: 200px;
                height: 500px;
                cursor: pointer;
                margin-right: 10px;
                position: relative;
                .play-btn {
                    display: none;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin-left: -50px;
                    margin-top: -50px;
                }
            }
            li:hover {
                .play-btn {
                    display: block;
                }
            }
        }
    }
    #guest-bg-area{
        background-position: top;
        background-repeat: no-repeat;
        margin-top: -1px;
    }
    .guest{
        overflow: auto;
        margin-bottom: 50px;
        overflow: hidden;
        ul.guest-list {
            margin: 0 auto;
            width: 1150px;
            overflow: visible;
            li {
                width: 200px;
                margin-left: 15px;
                overflow: hidden;
                -webkit-transition: all 0.3s;
                transition: all 0.3s;
                float: left;
                text-align: center;
                color: #273748;
                list-style: none;
                .photo {
                    overflow: hidden;
                    position: relative;
                    width: 200px;
                    height: 200px;
                    img {
                        display: block;
                        width: 200px;
                        height: 200px;
                        top: 0px;
                        left: 0px;
                        z-index: 99;
                        position: absolute;
                    }
                }
                .name-wrap{
                    position: relative;
                    overflow: hidden;
                    width: 200px;
                    height: 120px;
                    color: #fffdff;
                    text-align: left;
                    .name {
                        font-weight: bold;
                        text-align: center;
                        font-size: 24px;
                        height: 48px;
                        line-height: 48px;
                    }
                    .company {
                        text-align: center;
                        font-size: 16px;
                        line-height: 1.2;
                        padding-bottom: 18px;
                        font-weight: bold;
                    }
                }
                &:hover{
                    .name-wrap{
                        background-size: contain;
                    }
                }

                &:nth-child(5n) {
                    margin-right: 0;
                }
                &:nth-child(3){
                    .right-bottom{
                        background-color: #c42634;
                    }
                }
                &:nth-child(10){
                    .left-top{
                        background-color: #c42634;
                    }
                }
            }
        }
    }
    .agenda{
        width: 1200px;
        margin: 0 auto;
        color: #fff;
        .agenda-group-0, .agenda-group-1, .agenda-group-2, .agenda-group-3{
            vertical-align: top;
            margin-top: 0px;
            background-size: 100%;
            width: 1100px;
            margin-bottom: 40px;
            // border: 1px solid red;
        }
        .title{
            height: 200px;
        }
        .agenda-menu, .agenda-menu2{
            position: fixed;
            top: 60px;
            margin-left: auto!important;
            width: 140px;
            min-height: 400px;
            color: #392f86;
            .date{
                height: 50px;
                line-height: 50px;
                color: #333;
                font-size: 30px;
                font-weight: bold;
                text-align: center;
                span{
                    font-weight: normal;
                    font-size: 20px;
                }
            }
            .item{
                cursor: pointer;
                height: 40px;
                line-height: 40px;
                width: 140px;
                color: #333;
                opacity: 0.5;
                font-size: 20px;
                text-align: center;
                margin-bottom: 2px;
                border-radius: 0 4px 4px 0;
            }
            .vip{
                cursor: pointer;
                margin-left: -10px;
                width: 210px;
                height: 50px;
                line-height: 50px;
                font-size: 22px;
                color: #fff;
                background-color: #ffa800;
                text-align: center;
                font-weight: bold;
            }
            .bottom-img{
                width: 200px;
                height: 10px;
                background:{
                    image: url('../assets/menu-bottom.png');
                    repeat: no-repeat;
                    size: 100%;
                }
            }
            .triangle-left{
                float: left;
                width: 0;
                height: 0;
                border-top: 10px solid #223752;
                border-left: 10px solid transparent;
            }
            .triangle-right{
                float: left;
                width: 0;
                height: 0;
                border-top: 10px solid #223752;
                border-right: 10px solid transparent;
            }
        }
        .agenda-menu2{
            position: relative;
            float: left;
            top: 0;
        }
        .conf-host{
            margin-bottom: 20px;
            font-size: 22px;
            font-weight: bold;
            .which-conf{
                display: inline-block;
                font-size: 32px;
                margin-bottom: 5px;
                margin-left: 30px;
                span{
                    font-weight: bold;
                    display: inline-block;
                    height: 40px;
                }
                .see-map {
                    color: #fff;
                    font-size: 24px;
                    margin-left: 20px;
                    font-weight: lighter;
                }
            }
            .which-host{
                display: inline-block;
                font-size: 20px;
                margin-left: 10px;
                vertical-align: bottom;
            }
        }
        .agenda-list{
            font-size: 0px;
        }
    }
    #tickets-bg-area{
        // height: 570px;
    }
    #participator-area {
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        .participator-content {
            background: url('../assets/e-wap/analyze-bg.png');
            .item {
                width: 300px;
                height: 300px;
                color: #fff;
                font-size: 28px;
                display: inline-block;
                padding-top: 100px;
                background: url('../assets/e-pc/red-circle.png');
                background-repeat: no-repeat;
                background-position: center;
                .count {
                    font-size: 42px;
                    padding-top: 5px;
                }
            }
        }
    }
    .award {
        margin-top: 100px;
        .award-content {
            width: 1100px;
            margin: 0 auto;
            img {
                margin-right: 40px;
                margin-bottom: 40px;
                width: 500px;
                cursor: pointer;
                &:hover {
                    border: 1px solid red;
                }
            }
        }

    }
    .tickets{
        width: 100%;
        .rogers-area {
            display: block;
            height: 300px;
            width: 1030px;
            margin: 80px auto 30px;
            position: relative;
            cursor: pointer;
            background-repeat: no-repeat;
            background-image:url( "../assets/n-pc/pc-rogers-bg.png");
            .rogers {
                position: relative;
                float: left;
                margin-top: -116px;
                margin-left: 60px;
                z-index: 99;
                img{
                    width: 300px;
                }
            }
            .ticket-info {
                position: relative;
                float: right;
                color: #fff;
                height: 280px;
                width: 600px;
                padding-top: 20px;

                .name {
                    font-size: 38px;
                    font-weight: bold;
                }
                .price-line {
                    padding-top: 10px;
                    .price {
                        padding:0 8px;
                        margin: 5px 0;
                        margin-right: 15px;
                        height: 40px;
                        line-height: 40px;
                        font-size: 34px;
                        font-weight: bold;
                        display: inline-block;
                        background-color: #ec1c24;
                    }
                    span {
                        font-size: 28px;
                    }
                }
                .intro-line {
                    padding-top: 10px;
                    line-height: 1.5;
                    font-size: 18px;
                }
            }
            .buy-btn{
                display: none;
                position: absolute;
                z-index: 1;
                bottom: 20px;
                left: 0;
                right: 0;
                height: 100px;
                background: url('../assets/n-pc/big-buy-btn-bg.png');
            }
            &:hover{
                .buy-btn{
                    position: absolute;
                    display: block;
                }
            }
        }
        .tickets-content{
            width: 1100px;
            padding: 30px 0;
            margin: 0 auto;
            text-align: center;
            background-image: url('../assets/n-pc/ticket-bg.png');
            a{
                vertical-align: top;
                display: inline-block;
                text-decoration: none;
                margin-right: 40px;
            }

            .ticket0, .ticket2{
                background-image:url( "../assets/n-pc/ticket-bg1.png");
            }
            .ticket1, .ticket3{
                background-image:url( "../assets/n-pc/ticket-bg2.png");
            }
            .ticket-item{
                width: 230px;
                height: 345px;
                padding: 20px;
                background-repeat: no-repeat;
                text-decoration: none;
                color: #fff;
                position: relative;
                text-align: left;
                .name{
                    font-size: 27px;
                    font-weight: bold;
                }
                .price{
                    background-color: #ec1c24;
                    display: inline-block;
                    padding:0 8px;
                    margin: 5px 0;
                    font-size: 27px;
                    font-weight: bold;
                }
                .content{
                    font-size: 13px;
                    width: 200px;
                    line-height: 1.6;
                    text-align: left;
                }
                .seat{
                    position: absolute;
                    bottom: 18px;
                    left: 0;
                    right: 0;
                    font-size: 15px;
                    text-align: center;
                }
                .buy-btn{
                    display: none;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 100px;
                    background: url('../assets/n-pc/buy-btn-bg.png');
                }
                &:hover{
                    .buy-btn{
                        display: block;
                    }
                }
            }
        }
    }
    .old-guests{
        height: 800px;
        .container{
            max-width: 1200px;
            text-align: center;
            margin: 0 auto;
            .old-guest-item{
                display: inline-block;
                width: 173px;
                color: #ec1c24;
                text-align: center;
                margin-bottom: 15px;
                margin-right: 30px;
                img{
                    width: 173px;
                }
                .guest-name{
                    font-size: 18px;
                }
                .guest-title{
                    font-size: 13px;
                }
            }
        }
        .container :nth-child(6n){
            margin-right: 0px;
        }
    }
    .faq{
        .container{
            margin: 0 auto;
            width: 1200px;
            color: #fff;
            font-size: 24px;
            .line-a{
                margin-bottom: 10px;
            }
            .line-q, .line-a{
                span{
                    font-size: 30px;
                    color: #ec1c24;
                    padding-right: 4px;
                    vertical-align: top;
                }
                .content{
                    display: inline-block;
                    max-width: 1150px;
                }
            }
            .faq-more-btn{
                cursor: pointer;
                color: #ec1c24;
                text-align: center;
                margin-left: 0px;
                margin-bottom: 40px;
            }
            .sa-title{
                font-size: 30px;
                color: #ec1c24;
            }
            .sa-content{
                max-width: 1150px;
                margin-bottom: 20px;
            }

        }
    }
    .partners {
        overflow: auto;
        margin-bottom: 60px;
        .container{
            width: 1200px;
            margin: 0 auto;
            background-color: grey;
        }
        dl {
            dt {
                clear: left;
                width: 180px;
                margin: 0 auto;
                padding-top: 15px;
                font-size: 24px;
                color: #ec1c24;
                text-align: left;
                vertical-align: top;
                float: left;
                letter-spacing: 2px;
            }
            dd {
                min-height: 57px;
                display: block;
                float: left;
                width: 1000px;
                margin-bottom: 20px;
                img {
                    height: 66px;
                    margin-right: 18px;
                    margin-bottom: 30px;
                }
            }
        }
    }
    .location{
        height: 600px;
        .top-icon{
            text-align: center;
            width: 400px;
            margin: 0 auto;
            margin-bottom: -10px;
        }
        .container{
            height: 600px;
            .location-wrap{
                color: #fff;
                max-width: 1160px;
                text-align: center;
                margin: -70px auto 0;
                .address-info{
                    width: 500px;
                    margin-right: -100px;
                    vertical-align: top;
                    text-align:left;
                    color: #fff;
                    font-size:18px;
                    display: inline-block;
                    margin-top: 100px;
                    div {
                        padding: 5px 0;
                    }
                }
                img {
                    display: inline-block;
                    width: 750px;
                }
            }
        }
    }
    .about-us{
        height: 480px;
        width: 100%;
        .about-us-wrap{
            width: 1200px;
            margin: 0 auto;
            .user-item{
                vertical-align: bottom;
                display: inline-block;
                width: 260px;
                line-height: 1.4;
                margin-right: 50px;
                .title{
                    color: #ec1c24;
                    font-size: 30px;
                    line-height: 30px;
                    padding-left: 4px;
                    margin-bottom: 20px;
                    font-weight: bold;
                }
                .name, .phone, .email{
                    color: #fff;
                    padding-left: 4px;
                    font-size: 24px;
                }
            }
            .qrcode{
                color: #fff;
                display: inline-block;
                text-align: center;
                vertical-align: bottom;
                img{
                    display: inline-block;
                    width: 120px;
                    height: 120px;
                }
            }
        }
    }
    .section{
        p{
            margin-bottom: 10px;
            height: 10px;
        }
        .s-title{
            max-width: 1200px;
            margin: 40px auto 50px;
            text-align: left;
            color: #fff;
            font-size: 40px;
            .en {
                font-size: 50px;
                font-weight: lighter;
            }
            .zh {
                display: inline-block;
                margin: 10px 0;
            }
            .zh::after {
                display: inline-block;
                content: "";
                height: 38px;
                padding-left: 8px;
                border-right: 1px solid green;
                padding-top: 4px;
                text-align:end;
                vertical-align: sub;
                border-right: 6px solid red;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-active {
        opacity: 0
    }
    .active-agenda-menu{
        opacity: 1!important;
    }
    .bottom-buy-link-float{
        position: fixed;
        cursor: pointer;
        bottom: 40px;
        right: 40px;
        z-index: 999;
    }
    .bg-color-0{
        background-color: #ffff00;
    }
    .bg-color-1{
        background-color: #00ffa2;
    }
    .bg-color-2{
        background-color: #00ffff;
    }
    .bg-color-3{
        background-color: #ff0f7a;
    }
    .active{
        display: block;
    }
    .no-more-invoice {
        vertical-align: top;
        color: red;
        display: inline-block;
        font-size: 20px;
        padding-top: 10px;
        padding-left: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// HomePc.vue?14caa75f